import 'css-chunk:src/app/containers/Settings/SettingsContent/InviteUserModal.scss';export default {
  "InviteUserModal": "_InviteUserModal_s9u49_1",
  "form": "_form_s9u49_1",
  "actions": "_actions_s9u49_1"
};